import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "1em",
              fontFamily: "Nunito",
            }}
          >
            <ol>
              <li>
                Mooney, H., Larigauderie, A., Cesario, M., Elmquist, T.,
                Hoegh-Guldberg, O., Lavorel, S., Mace, G.M., Palmer, M.,
                Scholes, R. &amp; Yahara, T. (2009). Biodiversity, climate
                change, and ecosystem services. Current opinion in environmental
                sustainability, 1(1), 46-54.
                https://doi.org/10.1016/j.cosust.2009.07.006
              </li>
              <li>
                Bellard, C., Bertelsmeier, C., Leadley, P., Thuiller, W., &amp;
                Courchamp, F. (2012). Impacts of climate change on the future of
                biodiversity. Ecology letters, 15(4), 365-377.
                https://doi.org/10.1111/j.1461-0248.2011.01736.x
              </li>
              <li>
                Muluneh, M. G. (2021). Impact of climate change on biodiversity
                and food security: a global perspective&mdash;a review article.
                Agriculture &amp; Food Security, 10(1), 1-25.
                https://doi.org/10.1186/s40066-021-00318-5
              </li>
              <li>
                Prakash, S. (2021). Impact of Climate change on Aquatic
                Ecosystem and its Biodiversity: An overview. International
                Journal of Biological Innovations, 3(2).
                https://doi.org/10.46505/IJBI.2021.3210
              </li>
              <li>
                (2021) Desertification and land degradation atlas of India
                (Assessment and analysis of changes over 15 years based on
                remote sensing). Space Applications Center, ISRO, Ahmedabad.
                India.
                https://vedas.sac.gov.in/static/atlas/dsm/DLD_Atlas_SAC_2021.pdf
                (accessed on Dec, 2023).
              </li>
              <li>
                SAC, I. (2016). Desertification and land degradation atlas of
                India (Based on IRS AWiFS data of 2011-13 and 2003-05).
                Ahmedabad: Space Applications Centre, ISRO, Ahmedabad, India,
                219.
                https://www.sac.gov.in/SACSITE/Desertification_Atlas_2016_SAC_ISRO.pdf
                (accessed on Dec, 2023).
              </li>
              <li>
                Ramachandra, T.V., Subash Chandran, M.D, Joshi, N.V &amp;
                Sumesh, Dudani. (2013). Exploring Biodiversity and Ecology of
                Central Western Ghats., Sahyadri Conservation Series 13, ENVIS
                Technical Report: 39, March 2012, Energy &amp; Wetlands Research
                Group, Centre for Ecological Sciences, Indian Institute of
                Science, Bangalore 560 012.
              </li>
              <li>
                Joshi, V.C. &amp; Janarthanam, M.K. 2004. The diversity of
                life-form type, habitat preference and phenology of the endemics
                in the Goa region of the Western Ghats, India. J. Biogeography
                31: 1227-1237.
              </li>
              <li>
                Prabhugaonkar, A. 2014. First report of three red-listed tree
                species from swampy relics of Goa State, India. J. Threatened
                Taxa 6: 5503-5506.
              </li>
              <li>
                Goa Forest Department. "Mangroves in Goa."{" "}
                <a href="https://www.forest.goa.gov.in/mangroves">
                  https://www.forest.goa.gov.in/mangroves
                </a>{" "}
                (accessed on Feb, 2023).
              </li>
              <li>
                Baidya, P., &amp; Bhagat, M. (2018). A checklist of the birds of
                Goa, India. Indian Birds, 14(1), 1-31.
              </li>
              <li>
                Western Ghats Biodiversity Information System (WGBIS), Centre
                for Ecological Sciences, Indian Institute of Science, Bangalore.
                Accessed on 23 February 2024. https://wgbis.ces.iisc.ac.in/
              </li>
              <li>
                Ramachandra, T.V., Bharath Setturu, Vinay S, MD Subash Chandran,
                Bharath H. Aithal, Abhishek Baghel (2023), Western Ghats Spatial
                Decision Support System [WGSDSS]{" "}
                <a href="https://wgbis.ces.iisc.ac.in/sdss/wgsdss/">
                  https://wgbis.ces.iisc.ac.in/sdss/wgsdss/
                </a>
              </li>
              <li>
                Biodiversity, Energy &amp; Environmental Information System,
                Environmental Information System (ENVIS), Centre for Ecological
                Sciences, Indian Institute of Science, Bangalore. Accessed on 23
                February 2024.{" "}
                <a href="https://wgbis.ces.iisc.ac.in/energy_database">
                  https://wgbis.ces.iisc.ac.in/energy_database
                </a>
              </li>
              <li>
                Ramachandra, T.V., Setturu, Bharath, &amp; S., Vinay. (2021)
                Assessment of Forest Transitions and Regions of Conservation
                Importance in Udupi district, Karnataka. Indian Forester, 147(9)
                : 834-847.{" "}
                <a href="https://doi.org/10.36808/if/2021/v147i9/164166">
                  https://doi.org/10.36808/if/2021/v147i9/164166
                </a>
              </li>
              <li>
                Kimmins, J. P. (2003). Old-growth forest: An ancient and stable
                sylvan equilibrium, or a relatively transitory ecosystem
                condition that offers people a visual and emotional feast?
                Answer it depends. The Forestry Chronicle, 79(3), 429-440.{" "}
                <a href="https://doi.org/10.5558/tfc79429-3">
                  https://doi.org/10.5558/tfc79429-3
                </a>
              </li>
              <li>
                Betts, M. G., Wolf, C., Ripple, W. J., Phalan, B., Millers, K.
                A., Duarte, A., Butchart, S.H. &amp; Levi, T. (2017). Global
                forest loss disproportionately erodes biodiversity in intact
                landscapes. Nature, 547(7664), 441-444.{" "}
                <a href="https://doi.org/10.1038/nature23285">
                  https://doi.org/10.1038/nature23285
                </a>
              </li>
              <li>
                2022. The State of the World&rsquo;s Forests 2022. Forest
                pathways for green recovery and building inclusive, resilient
                and sustainable economies. Rome, FAO.
                https://doi.org/10.4060/cb9360en (accessed on Dec, 2023).
              </li>
              <li>
                India State of Forest Report (ISFR), 2023, Government of India.
                https://fsi.nic.in/forest-report-2023-details (accessed on Dec,
                2023).
              </li>
              <li>
                Hansen, A. J., Rotella, J. J., Kraska, M. P., &amp; Brown, D.
                (2000). Spatial patterns of primary productivity in the Greater
                Yellowstone Ecosystem. Landscape Ecology, 15, 505-522.
                https://doi.org/10.1023/A:1008127228878
              </li>
              <li>
                Xie, G., Zhang, C., Zhen, L., &amp; Zhang, L. (2017). Dynamic
                changes in the value of China&rsquo;s ecosystem services.
                Ecosystem services, 26, 146-154.
                https://doi.org/10.1016/j.ecoser.2017.06.010
              </li>
              <li>
                Forman, R. T., &amp; Godron, M. (1981). Patches and structural
                components for a landscape ecology. BioScience, 31(10), 733-740.{" "}
                <a href="https://doi.org/10.2307/1308780">
                  https://doi.org/10.2307/1308780
                </a>
              </li>
              <li>
                Haddad, N. M., Brudvig, L. A., Clobert, J., Davies, K. F.,
                Gonzalez, A., Holt, R. D., ... &amp; Townshend, J. R. (2015).
                Habitat fragmentation and its lasting impact on earth&rsquo;s
                ecosystems. Science advances, 1(2), e1500052.
                https://doi.org/10.1126/sciadv.1500052
              </li>
              <li>
                Laurance, W. F. (1999). Reflections on the tropical
                deforestation crisis. Biological conservation, 91(2-3), 109-117.
                https://doi.org/10.1016/S0006-3207(99)00088-9
              </li>
              <li>
                Ramachandra, T.V., Vinay, S., Bharath, S., Chandran, M. S.,
                &amp; Aithal, B. H. (2020). Insights into riverscape dynamics
                with the hydrological, ecological and social dimensions for
                water sustenance. Curr Sci, 118(9), 1379-1393.
              </li>
              <li>
                Laurance, W. F., Lovejoy, T. E., Vasconcelos, H. L., Bruna, E.
                M., Didham, R. K., Stouffer, P. C., Gascon, C., Bierregaard,
                R.O., Laurance, S.G. &amp; Sampaio, E. (2002). Ecosystem decay
                of Amazonian forest fragments: a 22‐year investigation.
                Conservation biology, 16(3), 605-618.
                https://doi.org/10.1046/j.1523-1739.2002.01025.x
              </li>
              <li>
                Laurance, W. F., Nascimento, H. E., Laurance, S. G., Andrade, A.
                C., Fearnside, P. M., Ribeiro, J. E., &amp; Capretz, R. L.
                (2006). Rain forest fragmentation and the proliferation of
                successional trees. Ecology, 87(2), 469-482.
                https://doi.org/10.1890/05-0064
              </li>
              <li>
                De Frenne, P., Lenoir, J., Luoto, M., Scheffers, B. R.,
                Zellweger, F., Aalto, J., ... &amp; Hylander, K. (2021). Forest
                microclimates and climate change: Importance, drivers and future
                research agenda. Global Change Biology, 27(11), 2279-2297.
                https://doi.org/10.1111/gcb.15569
              </li>
              <li>
                Grammatikopoulou, I., &amp; Vačk&aacute;řov&aacute;, D. (2021).
                The value of forest ecosystem services: A meta-analysis at the
                European scale and application to national ecosystem accounting.
                Ecosystem Services, 48, 101262.
                https://doi.org/10.1016/j.ecoser.2021.101262
              </li>
              <li>
                Ramachandra, T.V., &amp; Bharath, S. (2020). Carbon
                sequestration potential of the forest ecosystems in the Western
                Ghats, a global biodiversity hotspot. Natural Resources
                Research, 29(4), 2753-2771.
                https://doi.org/10.1007/s11053-019-09588-0
              </li>
              <li>
                Turner, W. R., Oppenheimer, M., &amp; Wilcove, D. S. (2009). A
                force to fight global warming. Nature, vol 428, pp 278&ndash;27.{" "}
                <a href="https://doi.org/10.1038/462278a">
                  https://doi.org/10.1038/462278a
                </a>
              </li>
              <li>
                Anees, S. A., Mehmood, K., Khan, W. R., Sajjad, M., Alahmadi, T.
                A., Alharbi, S. A., &amp; Luo, M. (2024). Integration of machine
                learning and remote sensing for above ground biomass estimation
                through Landsat-9 and field data in temperate forests of the
                Himalayan region. Ecological Informatics, 82, 102732.
                https://doi.org/10.1016/j.ecoinf.2024.102732
              </li>
              <li>
                Mehmood, K., Anees, S. A., Rehman, A., Tariq, A., Zubair, M.,
                Liu, Q., ... &amp; Luo, M. (2024). Exploring spatiotemporal
                dynamics of NDVI and climate-driven responses in ecosystems:
                Insights for sustainable management and climate resilience.
                Ecological Informatics, 80, 102532.{" "}
                <a href="https://doi.org/10.1016/j.ecoinf.2024.102532">
                  https://doi.org/10.1016/j.ecoinf.2024.102532
                </a>
              </li>
              <li>
                Hui, D., Deng, Q., Tian, H., &amp; Luo, Y. (2017). Climate
                change and carbon sequestration in forest ecosystems. Handbook
                of climate change mitigation and adaptation, 555, 594.
                https://doi.org/10.1007/978-1-4614-6431-0_13-2
              </li>
              <li>
                Allen, C. D., Macalady, A. K., Chenchouni, H., Bachelet, D.,
                McDowell, N., Vennetier, M., ... &amp; Cobb, N. (2010). A global
                overview of drought and heat-induced tree mortality reveals
                emerging climate change risks for forests. Forest ecology and
                management, 259(4), 660-684.{" "}
                <a href="https://doi.org/10.1016/j.foreco.2009.09.001">
                  https://doi.org/10.1016/j.foreco.2009.09.001
                </a>
              </li>
              <li>
                Rennert, K., Errickson, F., Prest, B. C., Rennels, L., Newell,
                R. G., Pizer, W., ... &amp; Anthoff, D. (2022). Comprehensive
                evidence implies a higher social cost of CO2. Nature, 610(7933),
                687-692. https://doi.org/10.1038/s41586-022-05224-9
              </li>
              <li>
                Gupta, A. K., Yadav, V. K., &amp; Bhushan, A. M. R. E. N. D. R.
                A. (2015). Recreational services valuation of Asiatic elephants
                in developing countries: a case study of Rajaji National Park,
                India. Indian for, 141, 1034-1041.
              </li>
              <li>
                Verma, M. (2000). Economic valuation of forests of Himachal
                Pradesh. Report on economic component of Himachal Pradesh
                forestry sector review, 7.
              </li>
              <li>
                Ramachandra, T. V., Aithal, B. H., Setturu, B., Vinay, S.,
                Asulabha, K. S., &amp; Sincy, V. (2024). Natural Capital
                Accounting and Valuation of Ecosystem Services, Karnataka State,
                India: Ecosystem Services. Springer Nature.
              </li>
              <li>
                Verma, M., Negandhi, D., Khanna, C., Edgaonkar, A., David, A.,
                Kadekodi, G., ... &amp; Kumar, S. (2017). Making the hidden
                visible: Economic valuation of tiger reserves in India.
                Ecosystem services, 26, 236-244.
              </li>
              <li>
                Kumar, S., &amp; Chaudhry, P. (2015). Ecosystem services
                valuation of the forests of Arunachal Pradesh State, India.
                Brazilian Journal of Biological Sciences, 2(4), 369-375.
              </li>
              <li>
                Ramachandra, T. V., Soman, D., Naik, A. D., &amp; Chandran, M.
                S. (2017). Appraisal of forest ecosystems goods and services:
                Challenges and opportunities for conservation. Journal of
                Biodiversity, 8(1), 12-33.
              </li>
              <li>
                Ramachandra, T. V., Bharath Setturu, V. S., Chandran, M. S.,
                Baghel, A., &amp; Aithal, B. H. (2024). Ecologically sensitive
                regions in the Western Ghats, a biodiversity hotspot. Indian
                Forester, 149, 1105-1121.
              </li>
              <li>
                Weiskopf, S. R., Rubenstein, M. A., Crozier, L. G., Gaichas, S.,
                Griffis, R., Halofsky, J. E., ... &amp; Whyte, K. P. (2020).
                Climate change effects on biodiversity, ecosystems, ecosystem
                services, and natural resource management in the United States.
                Science of the Total Environment, 733, 137782.
                https://doi.org/10.1016/j.scitotenv.2020.137782
              </li>
              <li>
                Pereira, P., Ignacio, M., Bogunivic, I., Francos, M.,
                Barcel&oacute;, D., &amp; Zhao, W. (2022). Ecosystem services in
                mountain environments: benefits and threats. Pirineos, 177,
                e068. https://doi.org/10.3989/pirineos.2022.177001
              </li>
              <li>
                Kindu, M., Schneider, T., Teketay, D., &amp; Knoke, T. (2016).
                Changes of ecosystem service values in response to land use/land
                cover dynamics in Munessa&ndash;Shashemene landscape of the
                Ethiopian highlands. Science of the Total Environment, 547,
                137-147. https://doi.org/10.1016/j.scitotenv.2015.12.127
              </li>
              <li>
                Zhu, L., Song, R., Sun, S., Li, Y., &amp; Hu, K. (2022). Land
                use/land cover change and its impact on ecosystem carbon storage
                in coastal areas of China from 1980 to 2050. Ecological
                Indicators, 142, 109178.
                https://doi.org/10.1016/j.ecolind.2022.109178
              </li>
              <li>
                Houghton, R. A., House, J. I., Pongratz, J., Van Der Werf, G.
                R., Defries, R. S., Hansen, M. C., Le Qu&eacute;r&eacute;, C
                &amp; Ramankutty, N. (2012). Carbon emissions from land use and
                land-cover change. Biogeosciences, 9(12), 5125-5142.
                https://doi.org/10.5194/bg-9-5125-2012
              </li>
              <li>
                Polasky, S., Nelson, E., Pennington, D., &amp; Johnson, K. A.
                (2011). The impact of land-use change on ecosystem services,
                biodiversity and returns to landowners: a case study in the
                State of Minnesota. Environmental and Resource Economics, 48,
                219-242. https://doi.org/10.1007/s10640-010-9407-0
              </li>
              <li>
                Bharath, S., Rajan, K. S., &amp; Ramachandra, T.V. (2014).
                Status and future transition of rapid urbanizing landscape in
                central Western Ghats - C.A. based approach, ISPRS Ann.
                Photogramm. Remote Sens. Spatial Inf. Sci., II-8, 69&ndash;75,
                https://doi.org/10.5194/isprsannals-II-8-69-2014.
              </li>
              <li>
                Vinay, S., Bharath, S., Bharath, H. A., &amp; Ramachandra, T.V.
                (2013, November). Hydrologic model with landscape dynamics for
                drought monitoring. In proceeding of: Joint International
                Workshop of ISPRS WG VIII/1 and WG IV/4 on Geospatial Data for
                Disaster and Risk Reduction, Hyderabad, November (pp. 21-22).
              </li>
              <li>
                Zhou, L., Pan, S., Wang, J., &amp; Vasilakos, A. V. (2017).
                Machine learning on big data: Opportunities and challenges.
                Neurocomputing, 237, 350-361.
                https://doi.org/10.1016/j.neucom.2017.01.026
              </li>
              <li>
                Sarker, I. H. (2021). Machine learning: Algorithms, real-world
                applications and research directions. SN computer science, 2(3),
                160. https://doi.org/10.1007/s42979-021-00592-x
              </li>
              <li>
                Breiman, L. (1996). Bagging predictors. Machine learning, 24,
                123-140. https://doi.org/10.1007/BF00058655
              </li>
              <li>
                Dietterich, T. G. (2000). Ensemble methods in machine learning.
                In International workshop on multiple classifier systems (pp.
                1-15). Berlin, Heidelberg: Springer Berlin Heidelberg.{" "}
                <a href="https://doi.org/10.1007/3-540-45014-9_1">
                  https://doi.org/10.1007/3-540-45014-9_1
                </a>
              </li>
              <li>
                Talukdar, S., Singha, P., Mahato, S., Pal, S., Liou, Y. A.,
                &amp; Rahman, A. (2020). Land-use land-cover classification by
                machine learning classifiers for satellite observations&mdash;A
                review. Remote sensing, 12(7), 1135.
              </li>
              <li>
                Mutale, B., Withanage, N. C., Mishra, P. K., Shen, J.,
                Abdelrahman, K., &amp; Fnais, M. S. (2024). A performance
                evaluation of random forest, artificial neural network, and
                support vector machine learning algorithms to predict
                spatio-temporal land use-land cover dynamics: a case from lusaka
                and colombo. Frontiers in Environmental Science, 12, 1431645.
              </li>
              <li>
                Loukika, K. N., Keesara, V. R., &amp; Sridhar, V. (2021).
                Analysis of land use and land cover using machine learning
                algorithms on google earth engine for Munneru River Basin,
                India. Sustainability, 13(24), 13758.
              </li>
              <li>
                Aryal, J., Sitaula, C., &amp; Frery, A. C. (2023). Land use and
                land cover (LULC) performance modeling using machine learning
                algorithms: a case study of the city of Melbourne, Australia.
                Scientific reports, 13(1), 13510.Brown et al. 2022
              </li>
              <li>
                Ramachandra, T.V., Mondal, T. &amp; Setturu, B. (2023). Relative
                performance evaluation of machine learning algorithms for land
                use classification using multispectral moderate resolution data.
                SN Appl. Sci. 5, 274. https://doi.org/10.1007/s42452-023-05496-4
              </li>
              <li>
                Ramachandra, T.V., Negi, P., &amp; Setturu, B. (2022). Insights
                from Big Spatial Data through Machine Learning Techniques for
                Prudent Management of Natural Resources. Journal of Resources,
                Energy and Development, 19(1-2),1-18.
                https://www.researchgate.net/publication/370130497_Insights_from_big_spatial_data_through_machine_learning_techniques_for_prudent_management_of_natural_resources
              </li>
              <li>
                Dong, L., Du, H., Mao, F., Han, N., Li, X., Zhou, G., ... &amp;
                Liu, T. (2019). Very high resolution remote sensing imagery
                classification using a fusion of random forest and deep learning
                technique&mdash;Subtropical area for example. IEEE Journal of
                Selected Topics in Applied Earth Observations and Remote
                Sensing, 13, 113-128.
              </li>
              <li>
                Boston, T., Van Dijk, A., Larraondo, P. R., &amp; Thackway, R.
                (2022). Comparing CNNs and random forests for Landsat image
                segmentation trained on a large proxy land cover dataset. Remote
                Sensing, 14(14), 3396.
              </li>
              <li>
                Adugna, T., Xu, W., &amp; Fan, J. (2022). Comparison of random
                forest and support vector machine classifiers for regional land
                cover mapping using coarse resolution FY-3C images. Remote
                Sensing, 14(3), 574.
              </li>
              <li>
                Abdel-Rahman, E. M., Mutanga, O., Adam, E., &amp; Ismail, R.
                (2014). Detecting Sirex noctilio grey-attacked and
                lightning-struck pine trees using airborne hyperspectral data,
                random forest and support vector machines classifiers. ISPRS
                Journal of Photogrammetry and Remote Sensing, 88, 48-59.
              </li>
              <li>
                Shang, X., &amp; Chisholm, L. A. (2013). Classification of
                Australian native forest species using hyperspectral remote
                sensing and machine-learning classification algorithms. IEEE
                Journal of Selected Topics in Applied Earth Observations and
                Remote Sensing, 7(6), 2481-2489.
              </li>
              <li>
                Ramachandra, T.V., Mondal, T., Setturu, B. &amp; Aithal, B.H.
                (2023). Environmental Consequences in the Neighbourhood of Rapid
                Unplanned Urbanisation in Bangalore City. Adv Environ Eng Res;
                4(4): 052;{" "}
                <a href="https://doi.org/10.21926/aeer.2304052">
                  https://doi.org/10.21926/aeer.2304052
                </a>
                .
              </li>
              <li>
                Setturu, B., &amp; Ramachandra, T.V. (2021). Modeling landscape
                dynamics of policy interventions in Karnataka State, India.
                Journal of Geovisualization and Spatial Analysis, 5(2), 22.
                https://doi.org/10.1007/s41651-021-00091-w
              </li>
              <li>
                Verburg, P. H., Alexander, P., Evans, T., Magliocca, N. R.,
                Malek, Z., Rounsevell, M. D., &amp; van Vliet, J. (2019). Beyond
                land cover change: towards a new generation of land use models.
                Current Opinion in Environmental Sustainability, 38, 77-85.
                https://doi.org/10.1016/j.cosust.2019.05.002
              </li>
              <li>
                Schuwirth, N., Borgwardt, F., Domisch, S., Friedrichs, M.,
                Kattwinkel, M., Kneis, D., Kuemmerlen, M., Langhans, S.D.,
                Mart&iacute;nez-L&oacute;pez, J. &amp; Vermeiren, P. (2019). How
                to make ecological models useful for environmental management.
                Ecological Modelling, 411, 108784.{" "}
                <a href="https://doi.org/10.1016/j.ecolmodel.2019.108784">
                  https://doi.org/10.1016/j.ecolmodel.2019.108784
                </a>
              </li>
              <li>
                Castella, J. C., Trung, T. N., &amp; Boissau, S. (2005).
                Participatory simulation of land-use changes in the northern
                mountains of Vietnam: the combined use of an agent-based model,
                a role-playing game, and a geographic information system.
                Ecology and Society, 10(1).
                https://www.jstor.org/stable/26267718
              </li>
              <li>
                Matthews, R. B., Gilbert, N. G., Roach, A., Polhill, J. G.,
                &amp; Gotts, N. M. (2007). Agent-based land-use models: a review
                of applications. Landscape Ecology, 22, 1447-1459.
                https://doi.org/10.1007/s10980-007-9135-1
              </li>
              <li>
                Wanyama, D., Mighty, M., Sim, S., &amp; Koti, F. (2021). A
                spatial assessment of land suitability for maize farming in
                Kenya. Geocarto International, 36(12), 1378-1395.
                https://doi.org/10.1080/10106049.2019.1648564
              </li>
              <li>
                Qiu, B. W., Chi, T. H., &amp; Wang, Q. M. (2005). Fruit tree
                suitability assessment using GIS and multi-criteria evaluation.
                Transaction of the CSAE, 21(6), 667-690.
              </li>
              <li>
                Nijkamp, P., Rietveld, P., &amp; Voogd, H. (2013).
                Multi-criteria evaluation in physical planning. Elsevier.
              </li>
              <li>
                Morales Jr, F., &amp; de Vries, W. T. (2021). Establishment of
                land use suitability mapping criteria using analytic hierarchy
                process (AHP) with practitioners and beneficiaries. Land, 10(3),
                235. https://doi.org/10.3390/land10030235
              </li>
              <li>
                Saaty, R. W. (1987). The analytic hierarchy process&mdash;what
                it is and how it is used. Mathematical modelling, 9(3-5),
                161-176. https://doi.org/10.1016/0270-0255(87)90473-8
              </li>
              <li>
                Pant, S., Kumar, A., Ram, M., Klochkov, Y., &amp; Sharma, H. K.
                (2022). Consistency indices in analytic hierarchy process: a
                review. Mathematics, 10(8), 1206.
                https://doi.org/10.3390/math10081206
              </li>
              <li>
                Saaty, T. L. (2008). Decision making with the analytic hierarchy
                process. International journal of services sciences, 1(1),
                83-98. https://doi.org/10.1142/S0219622005001453
              </li>
              <li>
                Saaty, T. L. (1977). A scaling method for priorities in
                hierarchical structures. Journal of mathematical psychology,
                15(3), 234-281. https://doi.org/10.1016/0022-2496(77)90033-5
              </li>
              <li>
                Dai, F. C., Lee, C. F., &amp; Zhang, X. H. (2001). GIS-based
                geo-environmental evaluation for urban land-use planning: a case
                study. Engineering geology, 61(4), 257-271.
                https://doi.org/10.1016/S0013-7952(01)00028-X
              </li>
              <li>
                de Ara&uacute;jo, C. C., &amp; Macedo, A. B. (2002).
                Multi-criteria geologic data analysis for mineral favorability
                mapping: application to a metal sulphide mineralized area,
                Ribeira Valley Metallogenic Province, Brazil. Natural Resources
                Research, 11, 29-43.
              </li>
              <li>
                Saaty, T. L. (1994). Fundamentals of decision making and
                priority theory with the analytic hierarchy process. RWS
                publications.
              </li>
              <li>
                Marinoni, O., &amp; Hoppe, A. (2006). Using the analytical
                hierarchy process to support sustainable use of geo-resources in
                metropolitan areas. Journal of Systems Science and Systems
                Engineering, 15, 154-164.
                https://doi.org/10.1007/s11518-006-5004-8
              </li>
              <li>
                &Ouml;zt&uuml;rk, D., &amp; Batuk, F. (2010). Analytic hierarchy
                process for spatial decision making. Sigma, 28(2), 124-137.
              </li>
              <li>
                Banai-Kashani, R. (1989). A new method for site suitability
                analysis: The analytic hierarchy process. Environmental
                management, 13, 685-693. https://doi.org/10.1007/BF01868308
              </li>
              <li>
                Van Laarhoven, P. J., &amp; Pedrycz, W. (1983). A fuzzy
                extension of Saaty's priority theory. Fuzzy sets and Systems,
                11(1-3), 229-24. https://doi.org/10.1016/S0165-0114(83)80082-7
              </li>
              <li>
                Buckley, J. J. (1985). Fuzzy hierarchical analysis. Fuzzy sets
                and systems, 17(3), 233-247.
                https://doi.org/10.1016/0165-0114(85)90090-9
              </li>
              <li>
                Chang, D. Y. (1996). Applications of the extent analysis method
                on fuzzy AHP. European journal of operational research, 95(3),
                649-655.{" "}
                <a href="https://doi.org/10.1016/0377-2217(95)00300-2">
                  https://doi.org/10.1016/0377-2217(95)00300-2
                </a>
              </li>
              <li>
                Anees, S. A., Mehmood, K., Rehman, A., Rehman, N. U., Muhammad,
                S., Shahzad, F., ... &amp; Khan, W. R. (2024). Unveiling
                fractional vegetation cover dynamics: A spatiotemporal analysis
                using modis ndvi and machine learning. Environmental and
                Sustainability Indicators, 24, 100485.
                https://doi.org/10.1016/j.indic.2024.100485
              </li>
              <li>
                de Barros Ruas, R., Costa, L. M. S., &amp; Bered, F. (2022).
                Urbanization driving changes in plant species and
                communities&ndash;A global view. Global Ecology and
                Conservation, 38, e02243.
              </li>
              <li>
                Government of Goa. (2022). Economic Survey 2021-22. Government
                of Goa.{" "}
                <a href="https://www.goa.gov.in/government/publications/">
                  https://www.goa.gov.in/government/publications/
                </a>{" "}
                (accessed on Feb, 2023).
              </li>
              <li>
                Simkin, R. D., Seto, K. C., McDonald, R. I., &amp; Jetz, W.
                (2022). Biodiversity impacts and conservation implications of
                urban land expansion projected to 2050. Proceedings of the
                National Academy of Sciences, 119(12), e2117297119.
              </li>
              <li>
                Wang, W., Wu, T., Li, Y., Xie, S., Han, B., Zheng, H., &amp;
                Ouyang, Z. (2020). Urbanization impacts on natural habitat and
                ecosystem services in the Guangdong-Hong Kong-Macao
                &ldquo;Megacity&rdquo;. Sustainability, 12(16), 6675.
              </li>
              <li>
                Ramachandra, T.V., Setturu, B., &amp; Chandran, S. (2016).
                Geospatial analysis of forest fragmentation in Uttara Kannada
                District, India. Forest Ecosystems, 3(1), 1-15.
                https://doi.org/10.1186/s40663-016-0069-4
              </li>
              <li>
                Eigenbrod, F., Bell, V. A., Davies, H. N., Heinemeyer, A.,
                Armsworth, P. R., &amp; Gaston, K. J. (2011). The impact of
                projected increases in urbanization on ecosystem services.
                Proceedings of the Royal Society B: Biological Sciences,
                278(1722), 3201-3208.
              </li>
              <li>
                Plummer, M. L. (2009). Assessing benefit transfer for the
                valuation of ecosystem services. Frontiers in Ecology and the
                Environment, 7(1), 38-45.{" "}
                <a href="https://doi.org/10.1890/080091">
                  https://doi.org/10.1890/080091
                </a>
              </li>
              <li>
                MoSPI (2020), Forests - the Climate Protectors (Chapter 3), Gov
                of India.
                https://mospi.gov.in/documents/213904//649960//1614147361232_b3_ES2_2020.pdf
                https://mospi.gov.in/sites/default/files/reports_and_publication/statistical_publication/EnviStats2/b3_ES2_2020.pdf
                (accessed on Feb, 2023).
              </li>
              <li>
                SEEA EA (2021) System of Environmental-Economic
                Accounting&mdash;Ecosystem Accounting, Final Draft, Version 5.
                Department of Economic and Social Affairs, Statistics Division,
                United Nations.
              </li>
              <li>
                Canu, D. M., Ghermandi, A., Nunes, P. A., Lazzari, P.,
                Cossarini, G., &amp; Solidoro, C. (2015). Estimating the value
                of carbon sequestration ecosystem services in the Mediterranean
                Sea: An ecological economics approach. Global Environmental
                Change, 32, 87-95.
                https://doi.org/10.1016/j.gloenvcha.2015.02.008
              </li>
              <li>
                Lorenz, K. (2010). Carbon sequestration in forest ecosystems.
                https://doi.org/10.1007/978-90-481-3266-9
              </li>
              <li>
                Anees, S. A., Mehmood, K., Khan, W. R., Shahzad, F., Zhran, M.,
                Ayub, R., ... &amp; Liu, Q. (2025). Spatiotemporal dynamics of
                vegetation cover: integrative machine learning analysis of
                multispectral imagery and environmental predictors. Earth
                Science Informatics, 18(1), 1-23.
                http://doi.org/10.1007/s12145-024-01673-0.
              </li>
              <li>
                Dhyani S (2018) Impact of forest leaf litter harvesting to
                support traditional agriculture in Western Himalayas. Trop Ecol
                59:473&ndash;488.
                http://216.10.241.130/pdf/open/PDF_59_3/7%20Shalini%20Dhyani.pdf.
              </li>
              <li>
                Laurance, W. F. (1999). Reflections on the tropical
                deforestation crisis. Biological conservation, 91(2-3), 109-117.
                https://doi.org/10.1016/S0006-3207(99)00088-9
              </li>
              <li>
                Ministry of Environment, Forest and Climate Change.
                (2018).&nbsp;Draft National Forest Policy, 2018. Government of
                India.{" "}
                <a href="https://moef.gov.in/uploads/2019/04/Inviting-comments-from-all-concerned-stakeholders-on-Draft-National-Forest-Policy-2018_1.pdf">
                  https://moef.gov.in/uploads/2019/04/Inviting-comments-from-all-concerned-stakeholders-on-Draft-National-Forest-Policy-2018_1.pdf
                </a>
                . (accessed on Feb, 2023).
              </li>
              <li>
                Sonak, S., Kazi, S., Sonak, M., &amp; Abraham, M. (2006).
                Factors affecting land-use and land-cover changes in the coastal
                wetlands of Goa. Multiple dimensions of global environmental
                change, 44.
              </li>
              <li>
                Clarke, K. C. (2021). Cellular automata and agent-based models.
                Handbook of regional science (pp. 1751-1766). Berlin,
                Heidelberg: Springer Berlin Heidelberg.
                https://doi.org/10.1007/978-3-662-60723-7_63
              </li>
              <li>
                Savin, I., Creutzig, F., Filatova, T., Foramitti, J., Konc, T.,
                Niamir, L., ... &amp; van den Bergh, J. (2023). Agent‐based
                modeling to integrate elements from different disciplines for
                ambitious climate policy. Wiley Interdisciplinary Reviews:
                Climate Change, 14(2), e811. https://doi.org/10.1002/wcc.811
              </li>
              <li>
                Silva, S. D., Nielsen, K. B., &amp; Bedi, H. P. (2020). Land use
                planning, dispossession and contestation in Goa, India. The
                Journal of Peasant Studies, 47(6), 1301-1326.
                https://doi.org/10.1080/03066150.2020.1822822
              </li>
              <li>
                Directorate of Mines and Geology (2023). https://dmg.goa.gov.in
                (accessed on Dec, 2023).
              </li>
              <li>
                Misra, A., &amp; P, V. (2015). Assessment of the land use/land
                cover (LU/LC) and mangrove changes along the Mandovi&ndash;Zuari
                estuarine complex of Goa, India. Arabian Journal of Geosciences,
                8, 267-279. https://doi.org/10.1007/s12517-013-1220-y
              </li>
              <li>
                Nagi, H. M., Rodrigues, R. S., Murali, M. R., &amp; Jagtap, T.
                G. (2014). Using remote sensing and GIS techniques for detecting
                land cover changes of mangrove habitats in Goa, India. Faculty
                of Science Bulletin, 26, 21-33.
              </li>
              <li>
                Morakar, P. R., Jakati, D. M., &amp; Hiremath, C. P. (2023).
                Geographical Analysis Of Climate Change Effects On Land Use
                &amp; Land Cover: A Case Study Of Goa. Journal of Namibian
                Studies: History Politics Culture, 33, 2098-2115.{" "}
                <a href="https://doi.org/10.59670/jns.v33i.2312">
                  https://doi.org/10.59670/jns.v33i.2312
                </a>
                .
              </li>
              <li>
                Ramachandra, T.V., Setturu, B., Rajan, K. S., &amp; Subash
                Chandran, M. D. (2017). Modelling the forest transition in
                Central Western Ghats, India. Spatial Information Research, 25,
                117-130. https://doi.org/10.1007/s41324-017-0084-8
              </li>
              <li>
                Costanza, R., d'Arge, R., De Groot, R., Farber, S., Grasso, M.,
                Hannon, B., ... &amp; Van Den Belt, M. (1997). The value of the
                world's ecosystem services and natural capital. nature,
                387(6630), 253-260. https://doi.org/10.1038/387253a0
              </li>
              <li>
                Costanza, R., De Groot, R., Sutton, P., Van der Ploeg, S.,
                Anderson, S. J., Kubiszewski, I., ... &amp; Turner, R. (2014).
                Changes in the global value of ecosystem services. Global
                environmental change, 26, 152-158.
                https://doi.org/10.1016/j.gloenvcha.2014.04.002
              </li>
              <li>
                De Groot, R., Brander, L., Van Der Ploeg, S., Costanza, R.,
                Bernard, F., Braat, L., ... &amp; Van Beukering, P. (2012).
                Global estimates of the value of ecosystems and their services
                in monetary units. Ecosystem services, 1(1), 50-61.
                https://doi.org/10.1016/j.ecoser.2012.07.005
              </li>
              <li>
                Ninan KN, Kontoleon A (2016) Valuing forest ecosystem services
                and disservices &ndash; Case study of a protected area in India,
                Ecosystem Services, 20 (2016): 1-14, ISSN 2212-0416,{" "}
                <a href="https://doi.org/10.1016/j.ecoser.2016.05.001">
                  https://doi.org/10.1016/j.ecoser.2016.05.001
                </a>
                .
              </li>
              <li>
                Comptroller and Auditor General of India. (2013). Report of the
                Comptroller and Auditor General of India on Compensatory
                Afforestation in India (Report No. 21 of 2013), Government of
                India.{" "}
                <a href="https://cag.gov.in/uploads/download_audit_report/2013/Union_Compliance_Civil_Compensatory_Afforestation_21_2013.pdf">
                  https://cag.gov.in/uploads/download_audit_report/2013/Union_Compliance_Civil_Compensatory_Afforestation_21_2013.pdf
                </a>{" "}
                (accessed on Feb, 2023).
              </li>
              <li>
                Champion, H. G. and Seth, S. K. (1968). A Revised Survey of
                Forest Types of India, Govt. of India Press, New Delhi, p. 404.
              </li>
              <li>
                Brown, C. F., Brumby, S. P., Guzder-Williams, B., Birch, T.,
                Hyde, S. B., Mazzariello, J., ... &amp; Tait, A. M. (2022).
                Dynamic World, Near real-time global 10 m land use land cover
                mapping. Scientific Data, 9(1), 251.
              </li>
              <li>
                -P. Pascal. (1984) Explanatory Booklet on the Forest Map of
                South India. Sheets: Belgaum-Dharwar-Panaji, Shimoga,
                Mercara-Mysore. Institut Fran&ccedil;ais de Pondich&eacute;ry,
                88 p., Travaux de la Section Scientifique et Technique. Hors
                S&eacute;rie N&deg; 18.
              </li>
              <li>
                Goa Forest Department.{" "}
                <a href="https://forest.goa.gov.in/">
                  https://forest.goa.gov.in/
                </a>{" "}
                (accessed on Feb, 2023).
              </li>
              <li>
                Breiman, L. (2001). Random forests. Machine learning, 45, 5-32.
                https://doi.org/10.1023/A:1010933404324
              </li>
              <li>
                Woznicki, S. A., Baynes, J., Panlasigui, S., Mehaffey, M., &amp;
                Neale, A. (2019). Development of a spatially complete floodplain
                map of the conterminous United States using random forest.
                Science of the total environment, 647, 942-953.
                https://doi.org/10.1023/A:1010933404324
              </li>
              <li>
                Abdi, A. M. (2020). Land cover and land use classification
                performance of machine learning algorithms in a boreal landscape
                using Sentinel-2 data. GIScience &amp; Remote Sensing, 57(1),
                1-20. https://doi.org/10.1080/15481603.2019.1650447
              </li>
              <li>
                Rodriguez-Galiano, V. F., Chica-Olmo, M., Abarca-Hernandez, F.,
                Atkinson, P. M., &amp; Jeganathan, C. (2012a). Random Forest
                classification of Mediterranean land cover using multi-seasonal
                imagery and multi-seasonal texture. Remote Sensing of
                Environment, 121, 93-107.
                https://doi.org/10.1016/j.rse.2011.12.003
              </li>
              <li>
                Rodriguez-Galiano, V. F., B. Ghimire, J. Rogan, M. Chica-Olmo,
                and J. P. Rigol-Sanchez. (2012b). &ldquo;An Assessment of the
                Effectiveness of a Random Forest Classifier for Land-cover
                Classification.&rdquo; ISPRS Journal of Photogrammetry and
                Remote Sensing 67: 93&ndash;104.
                https://doi.org/10.1016/j.isprsjprs.2011.11.002
              </li>
              <li>
                Riitters, K., Wickham, J., O&rsquo;Neill, R., Jones, B., &amp;
                Smith, E. (2000). Global-scale patterns of forest fragmentation.
                Conservation ecology, 4(2).
              </li>
              <li>
                Ra&scaron;i, R., Schwarz, M., Liaison Unit Bratislava, Zvolen,
                (2019). FOREST EUROPE 2019. Pilot study: Forest Fragmentation
                Indicator.
              </li>
              <li>
                Ramachandra, T.V., Bharath, S., &amp; Bharath, A. H. (2020).
                Insights of forest dynamics for the regional ecological
                fragility assessment. Journal of the Indian Society of Remote
                Sensing, 48(8), 1169-1189.
              </li>
              <li>
                Riitters, K. H., &amp; Coulston, J. W. (2005). Hot spots of
                perforated forest in the eastern United States. Environmental
                management, 35, 483-492.
              </li>
              <li>
                Lambin, E. F., Geist, H. J., &amp; Lepers, E. (2003). Dynamics
                of land-use and land-cover change in tropical regions. Annual
                review of environment and resources, 28(1), 205-241.
                https://doi.org/10.1146/annurev.energy.28.050302.105459
              </li>
              <li>
                Sang, L., Zhang, C., Yang, J., Zhu, D., &amp; Yun, W. (2011).
                Simulation of land use spatial pattern of towns and villages
                based on CA&ndash;Markov model. Mathematical and Computer
                Modelling, 54(3-4), 938-943.
                https://doi.org/10.1016/j.mcm.2010.11.019
              </li>
              <li>
                Bunruamkaew, K., &amp; Murayam, Y. (2011). Site suitability
                evaluation for ecotourism using GIS &amp; AHP: A case study of
                Surat Thani province, Thailand. Procedia-Social and Behavioral
                Sciences, 21, 269-278.
                https://doi.org/10.1016/j.sbspro.2011.07.024
              </li>
              <li>
                Ramachandra, T.V., &amp; Bharath, S. (2019). Global warming
                mitigation through carbon sequestrations in the Central Western
                Ghats. Remote Sensing in Earth Systems Sciences, 2, 39-63.
                https://doi.org/10.1007/s41976-019-0010-z
              </li>
              <li>
                Komiyama, A., Poungparn, S., &amp; Kato, S. (2005). Common
                allometric equations for estimating the tree weight of
                mangroves. Journal of tropical ecology, 21(4), 471-477.
                https://doi.org/10.1017/S0266467405002476
              </li>
              <li>
                Harishma, K. M., Sandeep, S., &amp; Sreekumar, V. B. (2020).
                Biomass and carbon stocks in mangrove ecosystems of Kerala,
                southwest coast of India. Ecological Processes, 9(1), 1-9.
                https://doi.org/10.1186/s13717-020-00227-8
              </li>
              <li>
                Vinod, K., Anasu Koya, A., Kunhikoya, V. A., Shilpa, P. G.,
                Asokan, P. K., Zacharia, P. U., &amp; Joshi, K. K. (2018).
                Biomass and carbon stocks in mangrove stands of Kadalundi
                estuarine wetland, south-west coast of India. Indian Journal of
                Fisheries, 65(2), 89-99.
                https://doi.org/10.21077/ijf.2018.65.2.72473-11
              </li>
              <li>
                Mizanur Rahman, M., Nabiul Islam Khan, M., Fazlul Hoque, A. K.,
                &amp; Ahmed, I. (2015). Carbon stock in the Sundarbans mangrove
                forest: spatial variations in vegetation types and salinity
                zones. Wetlands Ecology and Management, 23, 269-283.
                https://doi.org/10.1007/s11273-014-9379-x
              </li>
              <li>
                Nyeko, M. (2012). GIS and multi-criteria decision analysis for
                land use resource planning. DOI:10.4236/jgis.2012.44039
              </li>
              <li>
                Xie, G. D., Zhen, L., Lu, C. X., Xiao, Y., &amp; Chen, C.
                (2008). Expert knowledge based valuation method of ecosystem
                services in China. J. Nat. Resour, 23(5), 911-919.
              </li>
            </ol>
          </p>
          <br />
          <br />
          <hr />
          <br />
        </div>
      }
    />
  );
}
export default ReferencesPage;
